/**
 * Asset Service
 * API calls for asset management
 */

import { apiClient } from './apiClient';
import { Asset, AssetStats, AssetFilters, MaintenanceRecord } from '../types/asset';

export const assetService = {
  /**
   * Get all assets with optional filtering
   */
  async getAssets(filters?: AssetFilters): Promise<{ assets: Asset[]; count: number }> {
    const params = new URLSearchParams();
    
    if (filters?.search) params.append('search', filters.search);
    if (filters?.landlordId) params.append('landlordId', filters.landlordId);
    if (filters?.propertyId && filters.propertyId !== 'all') params.append('propertyId', filters.propertyId);
    if (filters?.category && filters.category !== 'all') params.append('category', filters.category);
    if (filters?.status && filters.status !== 'all') params.append('status', filters.status);

    const response = await apiClient.get(`/getAssets?${params.toString()}`);
    return response.data;
  },

  /**
   * Get asset statistics
   */
  async getAssetStats(): Promise<{ stats: AssetStats }> {
    const response = await apiClient.get('/getAssetStats');
    return response.data;
  },

  /**
   * Create maintenance record
   */
  async createMaintenanceRecord(
    landlordId: string,
    assetId: string,
    recordData: Partial<MaintenanceRecord>
  ): Promise<{ recordId: string }> {
    const response = await apiClient.post('/createMaintenanceRecord', {
      landlordId,
      assetId,
      recordData,
    });
    return response.data;
  },

  /**
   * Get maintenance history for an asset
   */
  async getMaintenanceHistory(
    landlordId: string,
    assetId: string
  ): Promise<{ records: MaintenanceRecord[]; count: number }> {
    const response = await apiClient.get(
      `/getMaintenanceHistory?landlordId=${landlordId}&assetId=${assetId}`
    );
    return response.data;
  },
};
